import {EnvironmentInjector, Injectable, Type, ViewContainerRef} from '@angular/core';
import Point from '@arcgis/core/geometry/Point';
import type MapView from '@arcgis/core/views/MapView';

export type PopupTextField = {
  type: 'text';
  label: string;
  value: string | number | null | undefined;
};

export type PopupLinkField = {
  type: 'link';
  label: string;
  text?: string;
  urlText: string;
  href?: string;
  onClick?: (ev: MouseEvent, field: PopupLinkField) => void | boolean | Promise<void>;
};

export type PopupHtmlField = {
  type: 'html';
  label?: string;
  html: string;
};

export type PopupField = PopupTextField | PopupLinkField | PopupHtmlField;

@Injectable({ providedIn: 'root' })
export class PopupService {
  
  constructor(private env: EnvironmentInjector) {}
  
  public openPopup<T>(opts: {
    viewContainerRef: ViewContainerRef;
    view: MapView;
    location: Point;
    componentType: Type<T>
    title?: string;
    fields: PopupField[];
  }) {
    const { viewContainerRef, view, location, componentType, title, fields } = opts;
    
    if (viewContainerRef) {
      viewContainerRef.clear();
    }
    
    const componentRef = viewContainerRef.createComponent<T>(componentType, {
      environmentInjector: this.env,
    });
    componentRef.setInput('fields', fields);
    componentRef.changeDetectorRef.detectChanges();
    
    view.popup.autoCloseEnabled = false;
    view.popup.defaultPopupTemplateEnabled = false;
    
    view.openPopup({
      location,
      title: title ?? '',
      content: componentRef.location.nativeElement,
    });
    
    const remove = view.popup.watch('visible', (v) => {
      if (!v) {
        componentRef.destroy();
        remove?.remove();
      }
    });
    
    return componentRef;
  }
}
